import { Button } from 'global/components/Button'
import Dialog from 'global/guides/Dialog'
import { useNavigate } from 'react-router-dom'

interface IProps {
    submittedValues: any
    clearValues: () => void
    handleSubmit: (value: any) => any
}

export default function FormExcluirCalculo({
    submittedValues,
    clearValues,
    handleSubmit,
}: IProps) {
    const navigate = useNavigate()

    return (
        <Dialog.Root
            open={!!submittedValues}
            onClose={() => {
                clearValues()
                navigate(-1)
            }}
        >
            <Dialog.Title>
                Há registros fora do período de contratação do funcionário
            </Dialog.Title>
            <Dialog.Content>
                <span>
                    Deseja excluir o espelho do ponto{' '}
                    <strong>antes do dia de contratação</strong> e{' '}
                    <strong>depois do dia de rescisão</strong> do funcionário?
                </span>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Button
                    onClick={() => {
                        handleSubmit({
                            ...submittedValues,
                            apagarCalculo: false,
                        })

                        return navigate(-1)
                    }}
                >
                    Manter
                </Button>
                <Button
                    color="error"
                    onClick={() => {
                        handleSubmit({
                            ...submittedValues,
                            apagarCalculo: true,
                        })

                        return navigate(-1)
                    }}
                >
                    Excluir
                </Button>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
